(function () {
  const MAX_LENGTH = 500;
  const DISALLOWED_CHAR_REGEX =
    /[^0-9A-Za-zÄÖÜäöüßàáâãåæçèéêëìíîïñòóôõøùúûýÿœÀÁÂÃÅÆÇÈÉÊËÌÍÎÏÑÒÓÔÕØÙÚÛÝŸŒ .,!?;:'"()_$%&@#+=/\\[\]{}<>|^~`-]/g;

  function sanitizeValue(value) {
    return String(value || '')
      .replace(/\r\n/g, '\n')
      .replace(DISALLOWED_CHAR_REGEX, '')
      .slice(0, MAX_LENGTH);
  }

  function getFields(form) {
    if (!form || !form.id) return [];
    return Array.from(
      document.querySelectorAll('[data-agrotropic-product-line-note][form="' + form.id + '"]')
    );
  }

  function getErrorElement(field) {
    const wrapper = field.closest('[data-agrotropic-line-note-wrapper]');
    return wrapper ? wrapper.querySelector('.agrotropic-product-line-note__error') : null;
  }

  function getCounterElement(field) {
    const wrapper = field.closest('[data-agrotropic-line-note-wrapper]');
    return wrapper ? wrapper.querySelector('.agrotropic-product-line-note__counter') : null;
  }

  function updateCounter(field) {
    const counter = getCounterElement(field);
    if (!counter) return;
    counter.textContent = field.value.length + ' / ' + MAX_LENGTH;
  }

  function setFieldError(field, message) {
    const errorEl = getErrorElement(field);
    field.setAttribute('aria-invalid', message ? 'true' : 'false');

    if (!errorEl) return;

    if (message) {
      errorEl.textContent = message;
      errorEl.hidden = false;
    } else {
      errorEl.textContent = '';
      errorEl.hidden = true;
    }
  }

  function validateField(field) {
    const value = sanitizeValue(field.value);
    if (value !== field.value) {
      field.value = value;
    }

    updateCounter(field);

    if (field.dataset.required === 'true' && value.trim() === '') {
      setFieldError(field, field.dataset.errorRequired || 'Bitte füllen Sie dieses Feld aus.');
      field.focus();
      return false;
    }

    setFieldError(field, '');
    return true;
  }

  function bindField(field) {
    if (field.dataset.agrotropicLineNoteInit === 'true') return;
    field.dataset.agrotropicLineNoteInit = 'true';

    function handleInput() {
      const sanitized = sanitizeValue(field.value);
      if (sanitized !== field.value) {
        field.value = sanitized;
      }
      updateCounter(field);
      if (field.getAttribute('aria-invalid') === 'true') {
        validateField(field);
      }
    }

    field.addEventListener('input', handleInput);
    field.addEventListener('blur', function () {
      validateField(field);
    });
    field.addEventListener('paste', function (event) {
      event.preventDefault();
      const pasted = (event.clipboardData || window.clipboardData).getData('text');
      const start = field.selectionStart;
      const end = field.selectionEnd;
      const nextValue =
        field.value.slice(0, start) + pasted + field.value.slice(end);
      field.value = sanitizeValue(nextValue);
      const cursor = Math.min(start + pasted.length, field.value.length);
      field.setSelectionRange(cursor, cursor);
      handleInput();
    });

    updateCounter(field);
  }

  function bindForm(form) {
    if (!form || form.dataset.agrotropicLineNoteSubmit === 'true') return;
    if (!getFields(form).length) return;

    form.dataset.agrotropicLineNoteSubmit = 'true';
    form.addEventListener(
      'submit',
      function (event) {
        if (!window.agrotropicProductLineNote.validate(form)) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      },
      true
    );
  }

  function init() {
    document.querySelectorAll('[data-agrotropic-product-line-note]').forEach(bindField);
    document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(bindForm);
  }

  window.agrotropicProductLineNote = {
    validate: function (form) {
      const fields = getFields(form);
      if (!fields.length) return true;

      let isValid = true;
      fields.forEach(function (field) {
        if (!validateField(field)) {
          isValid = false;
        }
      });

      return isValid;
    },
    sanitize: sanitizeValue,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
